import React from 'react'; 
import PropTypes from 'prop-types';

class Faq extends React.Component {
    render() {
        if (!this.props.faqList) return null;
        const faqs = this.props.faqList.map((item, i) => (
            <div key={i}>
                <p>
                    <b>{item.q}</b>
                </p>
                <p>
                    <span dangerouslySetInnerHTML={{ __html: item.a }} />
                </p>
                {(i == this.props.faqList.length - 1) ? null : <hr className="faqhr" />}
            </div>
        ));

        return (<div id="needHelp">{faqs}</div>);
    }
}

Faq.propTypes = {
    faqList: PropTypes.array.isRequired
}
export default Faq;